import http from '@/utils/http';

/** 用户 */
const userApi = {
  /**
   * 获取登录信息
   */
  getLoginInfo() {
    return http.get('/api/user/info');
  },
};

export default userApi;
